import styles from './modal.module.css';
import { Button, RegularButtonProps } from '@/components/button';
import clsx from 'clsx';

interface ModalButtonConfig extends Omit<RegularButtonProps, 'children'> {
  text: string;
}

interface ModalButtonsProps {
  confirm: ModalButtonConfig;
  cancel: ModalButtonConfig;
}

export function ModalButtons({ confirm, cancel }: ModalButtonsProps) {
  return (
    <div className={styles.buttonContainer}>
      <Button className={clsx(styles.cancelButton, cancel.className)} {...cancel} leftIcon="close">
        {cancel.text}
      </Button>
      <Button
        className={clsx(styles.confirmButton, confirm.className)}
        {...confirm}
        leftIcon="check"
      >
        {confirm.text}
      </Button>
    </div>
  );
}
